
import Vue from "vue";
import { Route, NavigationGuardNext } from "vue-router";
import { policyChecker } from "@/shared/roles";
import store from "@/store";

export function policyGuard(to: Route, next: NavigationGuardNext<Vue>) {
  if (to.matched.some((x) => x.meta.policy)) {
    const poly = to.matched.find((x) => x.meta.policy)?.meta.policy;
    if (policyChecker(poly)(store.getters["auth/claims"])) {
      next();
    } else {
      next({ name: "Dashboard" });
    }
  } else {
    next();
  }
}